import React from 'react';
import { useLocation } from 'react-router-dom';
import { dataGridCurrencyFormatter, dataGridDateFormatter } from './dataGridHelpers';
import { aODatePickerMinDate, getMonthName } from './dateHelpers';
import { isRealNumber } from './numberHelpers';
import { componentIdStringGenerator, currencyStringFormatter } from './stringHelpers';

function QueryStrings() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export {
  QueryStrings,
  aODatePickerMinDate,
  componentIdStringGenerator,
  currencyStringFormatter,
  dataGridCurrencyFormatter,
  dataGridDateFormatter,
  getMonthName,
  isRealNumber,
};
